export default {
	dailyActivity: {
		dateSheetTitle: 'Datum wählen',
		deletedRecordFallbackModule: 'Datensatz',
		deletedRecordTitle: '{module} (gelöscht)',
		descriptor: {
			archive_archived: '{title} wurde archiviert',
			archive_unarchived: '{title} wurde aus dem Archiv geholt',
			globalization_added: '{title} wurde mit {user} geteilt',
			globalization_message_changed: 'Die Nachricht zum Teilen von {title} wurde geändert',
			globalization_removed: '{title} wird nicht mehr mit {user} geteilt',
			ido_added: '{title} wurde mit der Akte {idoTitle} verknüpft',
			ido_removed: 'Die Verknüpfung von {title} mit der Akte {idoTitle} wurde entfernt',
			status_ready: 'Der Status von {title} wurde auf {status} gesetzt',
			status_seen: 'Der Status von {title} wurde auf {status} gesetzt',
			status_unseen: 'Der Status von {title} wurde auf {status} gesetzt',
			unknown: '{title} geändert',
		},
		editHistoryLoading: 'Änderungen werden geladen…',
		emptyTitle: 'Keine Änderungen an diesem Tag',
		errorTitle: 'Aktionen konnten nicht geladen werden',
		export: {
			columnAction: 'Aktion',
			columnModule: 'Modul',
			columnTime: 'Zeit',
		},
		filterArchive: 'Archiviert',
		filterIdoEdit: 'Akte bearbeitet',
		filterLink: 'Verknüpfung',
		filterSectionActions: 'Aktionen',
		filterSectionModules: 'Module',
		filterShare: 'Geteilt',
		filterStatus: 'Status',
		filterTooltip: 'Filtern',
		historyExpand: 'Verlauf',
		hourActivityCount: '{count} Aktionen',
		hourSuffix: '{hour} Uhr',
		idoDeleted: 'Die Akte {idoTitle} wurde gelöscht',
		idoEditedNamed: 'An der Akte {idoTitle} wurden die Werte {fields} geändert',
		idoEditedNamedOne: 'An der Akte {idoTitle} wurde der Wert {fields} geändert',
		idoEditedOne: 'An der Akte {idoTitle} wurde 1 Wert geändert',
		idoEditedOther: 'An der Akte {idoTitle} wurden {count} Werte geändert',
		loading: 'Aktionen werden geladen…',
		moduleLabel: {
			activity: 'Aktivität',
			appointment: 'Termin',
			document: 'Dokument',
			email: 'E-Mail',
			ido: 'Akte',
			message: 'Nachricht',
			note: 'Merkzettel',
			phonecall: 'Anruf',
			task: 'Aufgabe',
		},
		nextDay: 'Nächster Tag',
		openIdo: 'Akte öffnen',
		prevDay: 'Vorheriger Tag',
		retry: 'Erneut versuchen',
		searchPlaceholder: 'Aktionen durchsuchen …',
		searchPlaceholderShort: 'Suchen …',
		statusValue: {
			ready: 'Erledigt',
			seen: 'In Bearbeitung',
			unseen: 'Ungesichtet',
		},
		title: 'Tagesaktionen',
		today: 'Heute',
		typeLabel: {
			archive_archived: 'Archiviert',
			archive_unarchived: 'Aus Archiv geholt',
			globalization_added: 'Geteilt',
			globalization_message_changed: 'Nachricht',
			globalization_removed: 'Teilen entfernt',
			ido_added: 'Verknüpft',
			ido_removed: 'Verknüpfung entfernt',
			idoEdit_deleted: 'Akte gelöscht',
			idoEdit_edited: 'Akte bearbeitet',
			status_ready: 'Erledigt',
			status_seen: 'In Bearbeitung',
			status_unseen: 'Ungesichtet',
		},
		userSelectSelf: 'Meine Aktionen',
		userSelectSheetTitle: 'Benutzerauswahl',
	},
};
